export default {
  destinations: `destinations`,
  tours: `one-day`,
  packages: `independents`,
  circuits: `multiple-days`,
}
